import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import { useNavigate } from "react-router"
import { useEffect, useState } from "react"

export default function DrawingLayouts() {
  const { urls } = useSelector((state: RootState) => state.Drawings)
  const { hasDownloaded } = useSelector((state: RootState) => state.Utilities)
  const navigate = useNavigate()
  const [options, setOptions] = useState([])
  
  useEffect(() => {
    (async () => {
      const successfulOptions = await Promise.allSettled(urls.map(async ({ label, id, data }) => {
        try {
          const response = await fetch(data)
          if (!response.ok) {
            throw new Error(`Failed to fetch: ${response.status}`)
          }
          const dd = await response.blob()
          
          if (dd.size === 0) {
            throw new Error('Empty blob received')
          }
          
          const blobUrl = window.URL.createObjectURL(dd)
          
          await new Promise((resolve, reject) => {
            const img = new Image()
            img.onload = resolve
            img.onerror = () => reject(new Error('Invalid image data'))
            img.src = blobUrl
          })
          
          return ({ url: blobUrl, id, label })
        } catch (error) {
          console.error(`Failed to load drawing ${label}:`, error)
          throw error
        }
      }))
      
      const validOptions = successfulOptions
        .filter(result => result.status === 'fulfilled')
        .map(result => result.value)
      
      setOptions(validOptions)
    })()
  }, [urls])
  
  return (
    <div>
      {options.length > 0 ? (
        options.map(({ url, label, id }) => {
          return (
            <div
              key={label}
              onClick={() => navigate(`/DrawingLayouts/MapView/${id}`)}
              className="flex gap-2 p-3 cursor-pointer border-b-2 hover:bg-orange-1000 hover:text-white">
              <img src={url} style={{ width: "50px" }} />
              <label>{label}</label>
            </div>
          )
        })
      ) : hasDownloaded.drawings && options.length === 0 ? (
        <div className="flex flex-col items-center justify-center p-8 text-center dark:text-gray-100">
          <p className="text-lg mb-2">
            This project has no drawings / maps currently loaded.
          </p>
          <p className="text-sm">
            If this is incorrect, please create a ServiceNow ticket.
          </p>
        </div>
      ) : (
        <div className="flex items-center justify-center p-8">
          <p className="text-gray-500">Loading drawings...</p>
        </div>
      )}
    </div>
  )
}